(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  var context = window.MutuLikoloAnalytics || {};
  function publish(name, detail) {
    var payload = Object.assign({ event: name, brand: 'Mutu Likolo', path: location.pathname }, detail || {});
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('mutulikolo:' + name, { detail: payload }));
  }
  publish('page_view', { page_type: context.pageType || 'other' });
  if (context.product) publish('view_item', context.product);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('form[action*="/cart/add"]')) publish('add_to_cart', { product_id: context.product && context.product.item_id });
    if (form.matches('form[action*="/search"]')) publish('search', { search_term: new FormData(form).get('q') || '' });
    if (form.matches('form[action*="/contact"]')) publish('newsletter_signup');
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[name="checkout"],a[href*="/checkout"]')) publish('begin_checkout');
    if (event.target.closest('[data-ml-promo-play]')) publish('promo_video_play', { campaign: 'Atako Nini' });
  });
})();
